import EventPackageSectionCreate from './EventPackageSectionCreate'
import EventPackageSectionEdit from './EventPackageSectionEdit'
import EventPackageSectionList from './EventPackageSectionList'
import { ListAlt } from '@mui/icons-material'

const EventPackageSectionIndex = {
  list: EventPackageSectionList,
  edit: EventPackageSectionEdit,
  create: EventPackageSectionCreate,
  icon: ListAlt,
}

export default EventPackageSectionIndex
